import { render, staticRenderFns } from "./RateOverallStats.vue?vue&type=template&id=63c9af54"
import script from "./RateOverallStats.vue?vue&type=script&lang=js"
export * from "./RateOverallStats.vue?vue&type=script&lang=js"
import style0 from "./RateOverallStats.vue?vue&type=style&index=0&id=63c9af54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports